import React from "react";
import { Megaphone } from "lucide-react";
import { useApp } from "../context/AppContext";
import { BatchCollectCard } from "../components/finance/BatchCollectCard";
import { ReceiptVerifyAlertsCard } from "../components/finance/ReceiptVerifyAlertsCard";

/* 财务 · 批量催收：勾选多位已开票未收的已签约客户 → 一轮中英文提醒（与 CRM 已签约客户页同一组件 / 后台）。下方：回执核验监控（财务 / 管理员 / CEO）。 */
export default function FinanceBatchCollect() {
  const { api, lang, user } = useApp();
  const zh = lang === "zh";
  return (
    <div className="space-y-4" data-testid="fin-batch-collect-page">
      <div className="flex flex-wrap items-center gap-2">
        <Megaphone className="h-5 w-5 text-red-600" />
        <h1 className="text-xl sm:text-2xl font-bold text-slate-900">{zh ? "批量催收" : "Batch collection"}</h1>
        <span className="text-xs text-slate-400">{zh ? "已签约客户 · 合同期已开票未收（与客户详情 / 项目财务同一后台）" : "Signed customers · invoiced-unpaid contract periods (same backend as customer detail / project finance)"}</span>
      </div>
      <BatchCollectCard api={api} zh={zh} />
      {["admin", "finance", "ceo"].includes(user?.role) && <ReceiptVerifyAlertsCard api={api} zh={zh} />}
    </div>
  );
}
